/* eslint-disable max-len */
import 'react';

const ShareToRuLiuSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const id = `ShareToRuLiuSvg${Date.now()}`;
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_32093_23516" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                <rect width="18" height="18" fill="black" />
            </mask>
            <g mask="url(#mask0_32093_23516)">
                <path d="M14.25 3.75L8.0625 9.9375" stroke="#3377FF" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15 6L15 2.90625L11.9063 2.90625" stroke="#3377FF" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8.8125 3.01172L4.125 3.01172C3.29657 3.01172 2.625 3.68329 2.625 4.51172L2.625 13.5C2.625 14.3284 3.29657 15 4.125 15L13.5 15C14.3284 15 15 14.3284 15 13.5L15 8.8125" stroke="#3377FF" strokeWidth="1.125" strokeLinecap="round" />
            </g>
        </svg>

    );
};
export default ShareToRuLiuSvg;
